// Drag any slide-up sheet (.grit-sheet) down to close it, the way iOS sheets work.
// One delegated listener for the whole app. The sheet follows the finger 1:1 from where
// it was grabbed, resists if pulled up (rubber band), and on release decides from where
// the flick WOULD land (Apple's momentum projection, rate 0.998), not where the finger
// stopped. Closing taps the dimmed backdrop, which every sheet already treats as "close".

const DEAD_ZONE = 8;

function project(velocityPxPerSec, rate = 0.998) {
  return ((velocityPxPerSec / 1000) * rate) / (1 - rate);
}
function rubberband(overshoot, dimension, c = 0.55) {
  return (overshoot * dimension * c) / (dimension + c * Math.abs(overshoot));
}
const reduceMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export function initSheetDrag() {
  let s = null; // active drag state

  document.addEventListener('pointerdown', (e) => {
    const sheet = e.target.closest?.('.grit-sheet');
    if (!sheet || e.button > 0) return;
    if (e.target.closest('input, textarea, select')) return;
    // Only drag from the top of the content; otherwise let it scroll.
    const scroller = e.target.closest('.overflow-y-auto, .overflow-auto');
    if (scroller && scroller !== sheet && scroller.scrollTop > 0) return;
    if (sheet.scrollTop > 0) return;
    s = { sheet, startY: e.clientY, y: 0, active: false, hist: [{ y: e.clientY, t: e.timeStamp }], id: e.pointerId };
  }, { passive: true });

  document.addEventListener('pointermove', (e) => {
    if (!s || e.pointerId !== s.id) return;
    const dy = e.clientY - s.startY;
    if (!s.active) {
      if (Math.abs(dy) < DEAD_ZONE) return;
      if (dy < 0) { s = null; return; } // an upward move is a scroll, not a dismiss
      s.active = true;
      try { s.sheet.setPointerCapture(e.pointerId); } catch { /* fine */ }
      s.sheet.style.animation = 'none';
      s.sheet.style.transition = 'none';
    }
    const h = s.sheet.offsetHeight;
    s.y = dy >= 0 ? dy : rubberband(dy, h);       // measured from the first touch, no dead-zone lag
    s.sheet.style.transform = `translateY(${s.y}px)`;
    s.hist.push({ y: e.clientY, t: e.timeStamp });
    if (s.hist.length > 6) s.hist.shift();
  }, { passive: true });

  const end = (e) => {
    if (!s || e.pointerId !== s.id) return;
    const { sheet, active, hist } = s;
    const y = s.y;
    s = null;
    if (!active) return;
    const a = hist[0], b = hist[hist.length - 1];
    const v = b.t > a.t ? ((b.y - a.y) / (b.t - a.t)) * 1000 : 0; // px per second
    const landing = y + project(v);
    const h = sheet.offsetHeight;
    const close = landing > h * 0.4;
    const ms = reduceMotion() ? 0 : 320;
    sheet.style.transition = `transform ${ms}ms cubic-bezier(0.32, 0.72, 0, 1)`;
    sheet.style.transform = close ? `translateY(${h + 40}px)` : 'translateY(0)';
    if (close) {
      const backdrop = sheet.parentElement;
      setTimeout(() => backdrop?.dispatchEvent(new MouseEvent('click', { bubbles: true })), ms);
    }
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
}
